import { useEffect, useState } from "react";
import {
  Box, Typography, Grid, Card, Avatar
} from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import BrushIcon from "@mui/icons-material/Brush";
import HomeIcon from "@mui/icons-material/Home";
import DevicesIcon from "@mui/icons-material/Devices";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import MovieIcon from "@mui/icons-material/Movie";
import GavelIcon from "@mui/icons-material/Gavel";
import CategoryIcon from "@mui/icons-material/Category";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import SchoolIcon from "@mui/icons-material/School";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PetsIcon from "@mui/icons-material/Pets";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { Loading } from "../../components/common/Loading";
import SectionService from "../../components/services/SectionServices";
import HomeMap from "../../components/home/HomeMap";
import { getLatestServices, getLatestPages, getMapServices } from "../../actions/profile";
import { getTopCategories } from "../../actions/categories";
import { toggleFavorite } from "../../actions/users";
import { urlImg, isEmpty } from "../../components/common/helpers";

import { useSelector, useDispatch } from "react-redux";

// Ícono según el nombre de la categoría (con respaldo genérico)
const iconFor = (name = "") => {
  const n = name.toLowerCase();
  if (/repar|manten|plome|electric|construc|albañil|carpint/.test(n)) return <BuildIcon />;
  if (/belle|estétic|estetic|peluqu|barber|maquill|uñas|spa/.test(n)) return <BrushIcon />;
  if (/hogar|casa|limpiez|jardin|domést|domest|mudanz/.test(n)) return <HomeIcon />;
  if (/tecno|comput|software|program|digital|inform|web|sistema/.test(n)) return <DevicesIcon />;
  if (/finanz|contab|fiscal|conta|seguro|inversi|crédit|credit/.test(n)) return <MonetizationOnIcon />;
  if (/entreten|evento|música|musica|fiesta|show|artíst|artist/.test(n)) return <MovieIcon />;
  if (/legal|jurídic|juridic|abogad|notar/.test(n)) return <GavelIcon />;
  if (/salud|médic|medic|enferm|psico|nutri|dental|dentista/.test(n)) return <LocalHospitalIcon />;
  if (/educa|clase|tutor|enseñ|curso|escuel|idioma/.test(n)) return <SchoolIcon />;
  if (/transport|automot|auto|veh|taxi|chofer|carga/.test(n)) return <DirectionsCarIcon />;
  if (/mascot|veterin|animal|perro|gato/.test(n)) return <PetsIcon />;
  if (/comida|gastro|restaur|cocina|chef|cater|banquet/.test(n)) return <RestaurantIcon />;
  if (/deport|fitness|gimnas|entrenam|yoga/.test(n)) return <FitnessCenterIcon />;
  if (/foto|video|cámar|camar|filmac/.test(n)) return <CameraAltIcon />;
  return <CategoryIcon />;
};

// Alterna los dos colores del bloque de categorías
const colorFor = (index) => index % 2 === 0 ? "#234095" : "#62CBB8";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);
  const loading = useSelector(state => state.user.loading);

  const [username, setUsername] = useState(null);
  const [latestServices, setLatestServices] = useState([]);
  const [latestPages, setLatestPages] = useState([]);
  const [topCategories, setTopCategories] = useState([]);
  const [mapServices, setMapServices] = useState([]);
  const updatesServices = moment().format("DD MMMM YYYY");

  useEffect(() => {
    if (user && user.name) {
      setUsername(user.name);
    }
  }, [user]);

  useEffect(() => {
    const fetchTopCategories = async () => {
      const data = await getTopCategories(7);
      setTopCategories(data || []);
    };
    fetchTopCategories();
  }, []);

  useEffect(() => {
    const fetchMapServices = async () => {
      const data = await getMapServices(40);
      setMapServices(data || []);
    };
    fetchMapServices();
  }, []);

  useEffect(() => {
    const fetchLatestPages = async () => {
      const data = await getLatestPages();
      const formattedPages = data.map(page => {
        let finalAvatarUrl = "";
        if (!isEmpty(page.authorAvatar)) {
          const avatarStr = page.authorAvatar.toString();
          if (avatarStr.startsWith("http")) {
            finalAvatarUrl = avatarStr;
          } else {
            const version = page.authorAvatarVersion ? `v${page.authorAvatarVersion}/` : "";
            finalAvatarUrl = `${urlImg}/w_150,h_150,c_fill/${version}users/${page.userId}/${page.authorAvatar}`;
          }
        }

        return {
          ...page,
          authorAvatar: finalAvatarUrl,
          image: !isEmpty(page.image) ? `${urlImg}/w_400,h_250,c_fill/paginas/${page._id}/${page.image}` : ""
        };
      });
      setLatestPages(formattedPages);
    };
    fetchLatestPages();
  }, []);

  useEffect(() => {
    const fetchLatestServices = async () => {
      const data = await getLatestServices();
      const formattedServices = data.map(serv => {
        let finalAvatarUrl = "";
        if (!isEmpty(serv.authorAvatar)) {
          const avatarStr = serv.authorAvatar.toString();
          if (avatarStr.startsWith("http")) {
            finalAvatarUrl = avatarStr;
          } else if (avatarStr.startsWith("//")) {
            finalAvatarUrl = avatarStr.replace(/^\/\//, "https://");
          } else {
            const version = serv.authorAvatarVersion ? `v${serv.authorAvatarVersion}/` : "";
            finalAvatarUrl = `${urlImg}/w_150,h_150,c_fill/${version}users/${serv.userId}/${serv.authorAvatar}`;
          }
        }

        return {
          ...serv,
          authorAvatar: finalAvatarUrl,
          image: !isEmpty(serv.image) ? `${urlImg}/w_400,h_250,c_fill/servicios/${serv._id}/${serv.image}` : ""
        };
      });
      setLatestServices(formattedServices);
    };
    fetchLatestServices();
  }, []);

  const servicesWithFav = latestServices.map(s => ({
    ...s,
    favorite: user?.favorites?.some(f => f.toString() === s._id?.toString())
  }));

  const pagesWithFav = latestPages.map(p => ({
    ...p,
    favorite: user?.favorites?.some(f => f.toString() === p._id?.toString())
  }));

  if (loading) {
    return <Loading />
  }

  const changeFavoriteService = (service) => {
    dispatch(toggleFavorite(service._id));
  }

  const irA = where => {
    navigate(where);
  }

  return (
    <Box className="main-page">
      <Box
        sx={{
          bgcolor: "#7495f8",
          color: "white",
          borderRadius: 2,
          px: 4,
          py: 5,
          mb: 3,
        }}
      >
        <Typography variant="h5">
          Hola, <strong>{username}</strong>
        </Typography>
        <Typography variant="h5" fontWeight="bold">
          Explora servicios cercanos
        </Typography>
        <Typography variant="body1" mt={2}>
          Servicios actualizados al {updatesServices}
        </Typography>
      </Box>

      <Typography color="primary" variant="h6" sx={{ mb: 2 }}>
        Servicios en el mapa
      </Typography>
      <HomeMap servicios={mapServices} />

      {topCategories.length > 0 && (
        <>
          <Typography color="primary" variant="h6" sx={{ mb: 2 }}>
            Explora nuestras categorías
          </Typography>
          <Grid container spacing={2} sx={{ mb: 5 }}>
            {topCategories.map((cat, index) => (
              <Grid key={cat._id || index} size={{ xs: 6, md: "grow" }}>
                <Card
                  className="card-categories"
                  onClick={() => irA(`/buscar?categoria=${cat._id}`)}
                  sx={{
                    textAlign: "center",
                    p: 2,
                    borderRadius: 3,
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#EAEFFF" },
                    alignContent: "center"
                  }}
                >
                  <Avatar sx={{ bgcolor: colorFor(index), width: 56, height: 56, mx: "auto", mb: 1 }}>
                    {iconFor(cat.name)}
                  </Avatar>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight="bold"
                    mt={2}
                  >
                    {cat.name}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
      <SectionService
        title="Servicios destacados"
        subtitle="Algunos servicios que creemos podrían interesarte"
        services={servicesWithFav}
        favoriteService={changeFavoriteService}
        irA={() => irA("/admin/servicios")}
        onVerDetalle={(srv) => irA(`/servicio/${srv.userId}/${srv._id}`)}
        showPriece
      />
      <SectionService
        title="Páginas de servicios independientes"
        subtitle="Encuentra al profesional ideal para lo que necesites"
        services={pagesWithFav.filter(p => p.membersCount <= 1)}
        favoriteService={changeFavoriteService}
        irA={() => irA("/home")}
        onVerDetalle={(page) => irA(`/pagina/${page._id}`)}
        showAvailability
      />
      <SectionService
        title="Páginas de grupos y negocios"
        subtitle="Empresas y equipos especializados a tu disposición"
        services={pagesWithFav.filter(p => p.membersCount > 1)}
        favoriteService={changeFavoriteService}
        irA={() => irA("/home")}
        onVerDetalle={(page) => irA(`/pagina/${page._id}`)}
        showAvailability
      />
    </Box>
  );
}

export default Home;
